import { render, staticRenderFns } from "./DisputeContent.vue?vue&type=template&id=f2f635e4&scoped=true&"
import script from "./DisputeContent.vue?vue&type=script&lang=js&"
export * from "./DisputeContent.vue?vue&type=script&lang=js&"
import style0 from "./DisputeContent.vue?vue&type=style&index=0&id=f2f635e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f635e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VNavigationDrawer,VRow})
